export const initialState = {
    documents: [],
    activeDocumentId: null,
};
export const consentReducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DOCUMENTS':
            return { ...state, documents: action.payload };
        case 'ADD_DOCUMENT':
            return { ...state, documents: [...state.documents, action.payload] };
        case 'UPDATE_DOCUMENT':
            return {
                ...state,
                documents: state.documents.map((doc) => (doc.id === action.payload.id ? action.payload : doc)),
            };
        case 'ARCHIVE_DOCUMENT':
            return {
                ...state,
                documents: state.documents.map((doc) => doc.id === action.payload ? { ...doc, status: 'Archived', updatedAt: new Date().toISOString() } : doc),
            };
        case 'DELETE_DOCUMENT':
            return {
                ...state,
                documents: state.documents.filter((doc) => doc.id !== action.payload),
                activeDocumentId: state.activeDocumentId === action.payload ? null : state.activeDocumentId,
            };
        case 'SET_ACTIVE_DOCUMENT':
            return { ...state, activeDocumentId: action.payload };
        case 'SET_DOCUMENT_PDF': {
            const { documentId, pdfDataUrl } = action.payload;
            return {
                ...state,
                documents: state.documents.map((doc) => (doc.id === documentId ? { ...doc, pdfDataUrl } : doc)),
            };
        }
        case 'ADD_ELEMENT': {
            const { documentId, element } = action.payload;
            return {
                ...state,
                documents: state.documents.map((doc) => doc.id === documentId
                    ? { ...doc, elements: [...doc.elements, element], updatedAt: new Date().toISOString() }
                    : doc),
            };
        }
        case 'AUTO_MAP_ELEMENTS': {
            const { documentId, elements } = action.payload;
            if (elements.length === 0) {
                return state;
            }
            return {
                ...state,
                documents: state.documents.map((doc) => doc.id === documentId
                    ? { ...doc, elements: [...doc.elements, ...elements], updatedAt: new Date().toISOString() }
                    : doc),
            };
        }
        case 'UPDATE_ELEMENT': {
            const { documentId, element } = action.payload;
            return {
                ...state,
                documents: state.documents.map((doc) => doc.id === documentId
                    ? {
                        ...doc,
                        elements: doc.elements.map((el) => (el.id === element.id ? element : el)),
                        updatedAt: new Date().toISOString(),
                    }
                    : doc),
            };
        }
        case 'DELETE_ELEMENT': {
            const { documentId, elementId } = action.payload;
            return {
                ...state,
                documents: state.documents.map((doc) => doc.id === documentId
                    ? {
                        ...doc,
                        elements: doc.elements.filter((el) => el.id !== elementId),
                        updatedAt: new Date().toISOString(),
                    }
                    : doc),
            };
        }
        case 'UPDATE_DOCUMENT_ROLES': {
            const { documentId, roles } = action.payload;
            return {
                ...state,
                documents: state.documents.map((doc) => (doc.id === documentId ? { ...doc, roles } : doc)),
            };
        }
        default:
            return state;
    }
};
